import styles from './bank-account.module.scss';
import { Typography, Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { BankAccountCardProps } from 'modules/dashboard/types/widgets/widget.types';

export const BankAccountCard = ({
  logo,
  bankName,
  accountHolder,
  accountNumber,
  accountType,
  verified
}: BankAccountCardProps) => {
  const testComponentName = 'bankAccounts';
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <img
          src={logo}
          alt={`${bankName} logo`}
          className={styles.logo}
          data-testid={testComponentName + 'Logo'}
        />
        <Typography
          className={styles.bankName}
          variant={Typography.VARIANT.B3}
          weight={Typography.WEIGHT.MEDIUM}
          data-testid={testComponentName + 'BankName'}
        >
          <div className={styles.bankNameColor}>{bankName}</div>
        </Typography>
      </div>

      <div className={styles.cardBody}>
        <Typography
          color={Typography.COLOR.TERTIARY}
          variant={Typography.VARIANT.O3}
          weight={Typography.WEIGHT.MEDIUM}
          data-testid={testComponentName + 'AccountHolder'}
        >
          {accountHolder}
        </Typography>
        <Typography
          color={Typography.COLOR.TERTIARY}
          variant={Typography.VARIANT.O3}
          weight={Typography.WEIGHT.MEDIUM}
          data-testid={testComponentName + 'AccountNumber'}
        >
          {accountNumber}
        </Typography>
        <Typography
          color={Typography.COLOR.TERTIARY}
          variant={Typography.VARIANT.O3}
          weight={Typography.WEIGHT.MEDIUM}
          data-testid={testComponentName + 'AccountType'}
        >
          {accountType}
        </Typography>
      </div>

      <div className={`${styles.statusChip} ${verified ? styles.verified : styles.unverified}`}>
        {verified ? (
          <div className={styles.verificationContainer}>
            <Icon
              icon={ICONS_ENUM.ACTION_2_VERIFIED_USER}
              className={styles.verificationIcon}
              data-testid={testComponentName + 'VerificationBadge'}
            />
            <Typography
              color={Typography.COLOR.TERTIARY}
              variant={Typography.VARIANT.B3}
              weight={Typography.WEIGHT.NORMAL}
              data-testid={testComponentName + 'VerificationState'}
            >
              Verified
            </Typography>
          </div>
        ) : (
          <div className={styles.verificationContainer}>
            <Icon
              icon={ICONS_ENUM.ACTION_2_GPP_BAD}
              className={styles.verificationIcon}
              data-testid={testComponentName + 'VerificationBadge'}
            />
            <Typography
              color={Typography.COLOR.TERTIARY}
              variant={Typography.VARIANT.B3}
              weight={Typography.WEIGHT.NORMAL}
              data-testid={testComponentName + 'VerificationState'}
            >
              Unverified
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankAccountCard;
